/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnhancedAccordion } from 'components/enhanced/accordion';
import { MultipleAutocompleteAdapter } from 'components/enhanced/form/adapters/selects/MultipleAutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { IsSuperAdmin } from 'shared/permissions/IsSuperAdmin';
import { movementReasonService } from 'features/inventory/movements/api/movement-reason.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tenantSettingsService } from 'shared/services';
import { Option } from 'shared/types/general';
import toast from 'shared/utils/toast';

export function ConsumptionSettingsAccordion() {
  const { t } = useTranslation();
  const [movementReasons, setMovementReasons] = useState<Option[]>([]);
  const [tenantSettings, setTenantSettings] = useState<any>(null);

  useEffect(() => {
    tenantSettingsService.get(1).then(setTenantSettings);
    movementReasonService.getAllPaginated().then((res) => {
      setMovementReasons(res.results);
    });
  }, []);

  const onSubmit = (values: any) => {
    tenantSettingsService.update(1, values).then(() => {
      toast.success('Causali aggiornate con successo.');
    });
  };

  if (!tenantSettings) return null;

  return (
    <IsSuperAdmin>
      <EnhancedAccordion
        title={t('pages.consumption.settings_title')}
        subtitle={t('pages.consumption.settings_subtitle')}>
        <EnhancedForm onSubmit={onSubmit}>
          <IdentityField
            name="consumption_analysis_reasons"
            component={MultipleAutocompleteAdapter}
            options={movementReasons}
            initValue={tenantSettings.consumption_analysis_reasons}
            label={t('entities.tenant-settings.consumption-analysis-reasons')}
            type="text"
          />
        </EnhancedForm>
      </EnhancedAccordion>
    </IsSuperAdmin>
  );
}
